import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Hero from "./../assets/hero.jpg";
import MapImg from "../assets/helloCarMap.png";
import "./styles/home.css";

// ✅ DATA ARRAYS -----------------------------
const SERVICES = [
  "Accessories Installation",
  "Car Deep Cleaning",
  "Seat Covers & Interior Work",
  "Detailing & Polishing"
];

const POPULAR_PRODUCTS = ["Car Perfume", "Seat Covers", "Floor Mats"];

const TESTIMONIALS = [
  `"Amazing service, great quality accessories!"`,
  `"My car looks brand new after the detailing!"`,
  `"Brilliant customer support. Highly recommended."`
];

const FAQS = [
  {
    q: "Do you offer installation?",
    a: "Yes, we provide professional installation for all accessories."
  },
  {
    q: "Do you take bookings?",
    a: "Yes, you can book appointments directly through the website."
  },
  {
    q: "Are your products original?",
    a: "We deal only in premium, high-quality, authentic car accessories."
  }
];

export default function Home() {
  const navigate = useNavigate();
  const [productSearch, setProductSearch] = React.useState("");

  const goSearch = () => {
    if (!productSearch.trim()) return;
    navigate(`/products?search=${encodeURIComponent(productSearch)}`);
  };

  const MAP_URL =
    "https://www.google.com/maps/place/Hello+Car/@28.5727509,77.2359505,17z/data=!3m1!4b1!4m6!3m5!1s0x390ce3ad0fffffff:0x2d142ceca0573859!8m2!3d28.5727462!4d77.2385254!16s%2Fg%2F1tl1lv54?entry=ttu";

  // ✅ Scroll reveal animations
  React.useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add("active");
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="homepage">
      <main className="home-main">

        {/* ✅ HERO */}
        <section className="hero reveal" style={{ backgroundImage: `url(${Hero})` }}>
          <h1>Hello Car</h1>
          <h2>The One Stop Car Shop</h2>
          <NavLink className="btn" to="contacts">Learn More</NavLink>
        </section>                        {/*"about"*/}

        {/* ✅ FEATURES */}
        <section className="features reveal">

          <div className="feature">
            <NavLink to={MAP_URL} target="_blank">
              <h2>Location on Map</h2>
              <p>Click anywhere here to get our location online</p>
              <img src={MapImg} alt="HelloCar map" />
            </NavLink>
          </div>

          <div className="feature">
            <h2>Products</h2>
            <p>
              Explore our premium car accessories that will take your car
              to the next level.
            </p>

            {/* ✅ Mini Search */}
            <div className="home-product-search">
              <input
                type="text"
                placeholder="Search products..."
                value={productSearch}
                onChange={(e) => setProductSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && goSearch()}
              />
              <button onClick={goSearch}>Search</button>
            </div>

            <NavLink className="btn" to="products">
              View more on our Products Listing
            </NavLink>
          </div>

          <div className="feature">
            <NavLink to="contacts">
              <h2>Contact & Email</h2>
              <p>
                Phone: +91 9899208565 <br />
                Email: hellocarb77@gmail.com
              </p>
              <NavLink className="btn" to="contacts">
                View more Contact Details
              </NavLink>
            </NavLink>
          </div>

        </section>

        {/* ✅ ABOUT */}
        <section className="home-about reveal reveal-left">
          <h2>About Hello Car</h2>
          <p>
            At Hello Car, we bring premium car accessories, expert installation,
            and top-tier automotive services — all under one roof. Your car deserves the best.
          </p>
          <NavLink to="about" className="btn">Learn More</NavLink>
        </section>

        {/* ✅ SERVICES */}
        <section className="home-services reveal reveal-right">
          <h2>What We Offer</h2>
          <div className="services-grid">
            {SERVICES.map((service, i) => (
              <div key={i} className="service-box">{service}</div>
            ))}
          </div>
        </section>

        {/* ✅ POPULAR PRODUCTS */}
        <section className="home-products-preview reveal">
          <h2>Popular Products</h2>
          <div className="preview-grid">
            {POPULAR_PRODUCTS.map((p, i) => (
              <div key={i} className="p-card">{p}</div>
            ))}
          </div>
          <NavLink to="products" className="btn">Explore All Products</NavLink>
        </section>

        {/* ✅ TESTIMONIALS */}
        <section className="home-testimonials reveal reveal-left">
          <h2>What Our Customers Say</h2>
          <div className="testimonials-grid">
            {TESTIMONIALS.map((t, i) => (
              <p key={i}>{t}</p>
            ))}
          </div>
        </section>

        {/* ✅ MAP */}
        <section className="home-map reveal">
          <h2>Find Us</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.300859745735!2d77.2360009753462!3d28.572750986318404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3ad0fffffff%3A0x2d142ceca0573859!2sHello%20Car!5e0!3m2!1sen!2sin!4v1700000000000"
            loading="lazy"
            allowFullScreen
            title="Map"
          ></iframe>
        </section>

        {/* ✅ FAQ */}
        <section className="home-faq reveal reveal-right">
          <h2>Frequently Asked Questions</h2>

          {FAQS.map((item, i) => (
            <details key={i}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </section>

      </main>
    </div>
  );
}
